import * as React from "react";
import { useState, useEffect} from "react";
import {
  MapContainer,
  Marker,
  Popup,
  TileLayer,
  useMapEvents,
  CircleMarker,
  Polygon,
  SVGOverlay,
  Tooltip,
  FeatureGroup,
  useMap,
} from "react-leaflet";
import L from "leaflet";
import container1 from "../../../assets/svg/container1.svg";
import container2 from "../../../assets/svg/container2.svg";
import h2 from "../../../assets/svg/h2.svg";
import Button from "@mui/material/Button";
import { FxmsEvent, AlarmLevel } from "../../actions/FxEvent";
import { FxmsPopup } from "../../windows/FxWindows";
import { FxmsData } from "../../datas/FxData";
import { AttrListEdit } from "../../datas/OpClass";
import { FxTPDataGrid } from "../FxTPDataGrid";
import { Router, NavLink } from "react-router-dom";
import { updateValue } from "../../../modules/features/h2Slice";
import { useSelector, useDispatch  } from 'react-redux';

import "./FxMap.css";


const THINGSPIRE_LAT_LNG = [37.547005936682226, 126.97392404079439];

function makeMarker(data, icon, clickMarker, isClicked) {
  if(isClicked) {

  }
  const handleClick = (e) => {
    if (clickMarker) {
      clickMarker(data);
    }
  };
  return (
    <>
      <Marker
        eventHandlers={{
          click: handleClick,
        }}
        key={data.key}
        position={data.coord}
        icon={new L.Icon({
          iconUrl: isClicked ? "/icon_position_over.png" : "/icon_position.png",
          iconSize: [50, 65],
        })}
      >
        <Popup>
          <div>
            <h1>{data.title}</h1>
          </div>
        </Popup>
        <Tooltip direction="right" offset={[25, 0]} opacity={0.5} permanent>
          <div>
            <h3 style={{color: 'black'}}>{data.addr}</h3>
          </div>
        </Tooltip>
      </Marker>
    </>
  );
}

const FxMap = (props) => {
  const { id, fxUiGrpItem, editable, markerDatas, inloData } = props;
  const [map, setMap] = useState(null);
  const [markers, setMarkers] = useState([]);
  const [mapSource, setMapSource] = useState("base");
  const [icon, setIcon] = useState(h2);
  const h2Value = useSelector((state) => state.H2.value);
  const dispatch = useDispatch();
  const [clickedMarkerKey, setClickedMarkerKey] = useState(null);

  console.log("*** FxMap ***", props);

  useEffect(() => {
    const list = markerDatas ? markerDatas : selectMarkers();

    const markerComponents = list.map((data) => {
      const isClicked = data.key === clickedMarkerKey;
      return makeMarker(data, icon, clickMarker, isClicked);
    });

    setMarkers(markerComponents);

    if (clickedMarkerKey === null) {
      setClickedMarkerKey(1000);
    }

  }, [markerDatas, clickedMarkerKey]);

  useEffect(() => {
    const initMarker = markerDatas.find((marker) => marker.key === 1000);
    if (initMarker) {
      clickMarker(initMarker);
    }
  }, [markerDatas]);

  const MapClickEvent = () => {
    const map = useMapEvents({
      click: (e) => {
        let coord = e.latlng;
        console.log("MapClickEvent", e);
      },
    });
    return null;
  };

  function selectMarkers() {
    const ret = [];

    return ret;
  }

  function clickMarker(data) {
    console.log("clickMarker", data);
    dispatch(updateValue(data));
    FxmsEvent.event(data);
    setClickedMarkerKey(data.key);
  }

  if (editable) {
    return <div>MAP</div>;
  }

  return (
    <>
    <MapContainer
      attributionControl={false}
      style={{ height: "100%", width: "100%" }}
      center={[34.9619, 128.0565]}
      zoom={8}
      scrollWheelZoom={true}
      id={props.id}
      whenReady={setMap}
    >
      {mapSource == "base" ? (
        <TileLayer
          attribution="VWorldBase"
          url={
            "http://api.vworld.kr/req/wmts/1.0.0/E6E8A8C3-EF10-371F-81EA-97B22903FCE5/Base/{z}/{y}/{x}.png"
          }
        />
      ) : (
        ""
      )}
      <MapClickEvent />
      {markers}
      {
        <div style={{ position: "relative", width: "100%" }}>
          <div
            className="tpState"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, 10%)",
              zIndex: 1000,
              padding: "10px",
            }}
          >
          <div>
            <span>● 운전 :</span> {inloData.length}
          </div>
          <div>
            <span>● 알람 :</span> {0}
          </div>
          <div>
            <span>● 중지 :</span> {0}
          </div>
          </div>
        </div>
      }
    </MapContainer>
    </>
  );
};

/**
 * 지도로 위경도 구하는 편집기
 * refData = {"title":"inloName", "address":"addr", "lat":"ltd", "lng":"lnd"}
 * title : 제목 사용할 필드
 * address 주소를 나타내는 필드
 * lat : 위도 필드
 * lng : 경도 필드
 * @param {*} props
 * @returns
 */
export const FxMapLatLng = (props) => {
  const { attr, onSelectedLatLng, fxInObj, refData } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [coord, setCoord] = useState(null);
  const [title, setTitle] = useState(fxInObj[refData.title]);
  const disabled = attr.readOnlyYn === "Y";
  const fullWidth = false;
  const sx = {};
  if (attr.uiWidth > 0) {
    sx.minWidth = attr.uiWidth;
  } else {
    fullWidth = true;
  }
  const closeModal = () => {
    setModalOpen(false);
  };
  const openModal = () => {
    setModalOpen(true);
  };
  function clickMap(coord) {
    console.log("FxMapLatLng", coord);
    onSelectedLatLng(refData.lat, coord.lat);
    onSelectedLatLng(refData.lng, coord.lng);
  }

  useEffect(() => {
    console.log("FxMapLatLng", fxInObj);
    try {
      if (fxInObj && fxInObj[refData.lat] && fxInObj.lnd) {
        setCoord({ lat: fxInObj[refData.lat], lng: fxInObj[refData.lng] });
      } else {
        setCoord({ lat: THINGSPIRE_LAT_LNG[0], lng: THINGSPIRE_LAT_LNG[1] });
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  return (
    <>
      <Button
        className={"mui_button"}
        style={{ marginLeft: "10px", width: attr.uiWidth + "px", height: "33px" }}
        id={attr.attrName}
        variant="contained"
        onClick={openModal}
      >
        {attr.attrUiTxt}
      </Button>
      <FxmsPopup
        open={modalOpen}
        closeModal={closeModal}
        dialogTitle={attr.attrUiTxt}
      >
        <Map clickMap={clickMap} coord={coord} title={title} />
      </FxmsPopup>
    </>
  );
};


/**
 * 지도로 위경도 구하는 편집기
 * refData = {"title":"inloName", "address":"addr", "lat":"ltd", "lng":"lnd"}
 * title : 제목 사용할 필드
 * address 주소를 나타내는 필드
 * lat : 위도 필드
 * lng : 경도 필드
 * @param {*} props
 * @returns
 */
export const FxMapLatLng2 = (props) => {
  const { attrClass, para, defaultValue } = props;
  const sx = attrClass.getStyle();
  const [modalOpen, setModalOpen] = useState(false);
  const [coord, setCoord] = useState(null);
  const refData = attrClass.getEtcInfoObj();
  const attr = attrClass.getAttr();
  const [title, setTitle] = useState(para.selectedData ? para.selectedData[refData.title] : "위치 선택");

  console.log("FxMapLatLng", attrClass, refData);

  const fullWidth = false;
  if (attr.uiWidth > 0) {
    sx.minWidth = attr.uiWidth;
  } else {
    fullWidth = true;
  }
  const closeModal = () => {
    setModalOpen(false);
  };
  const openModal = () => {
    setModalOpen(true);
  };
  function clickMap(coord) {
    if (para.onChange) {
      para.onChange(refData.lat, coord.lat);
      para.onChange(refData.lng, coord.lng);
    }
  }
  function makeCoord() {
    try {
      if (para.selectedData) {
        if (Number(para.selectedData[refData.lat]) > 0 && Number(para.selectedData[refData.lng]) > 0) {
          return { lat: para.selectedData[refData.lat], lng: para.selectedData[refData.lng] }
        }
      }
    } catch (e) {
    }
    return { lat: THINGSPIRE_LAT_LNG[0], lng: THINGSPIRE_LAT_LNG[1] };
  }

  useEffect(() => {
    setCoord(makeCoord());
  }, []);

  return (
    <>
      <Button
        className={"mui_button"}
        style={{ marginLeft: "10px", width: attr.uiWidth + "px", height: "33px" }}
        id={attr.attrName}
        variant="contained"
        onClick={openModal}
      >
        {attr.attrUiTxt}
      </Button>
      <FxmsPopup
        open={modalOpen}
        closeModal={closeModal}
        dialogTitle={attr.attrUiTxt}
      >
        <Map clickMap={clickMap} coord={coord} title={title} />
      </FxmsPopup>
    </>
  );
};

const Map = (props) => {
  const { clickMap, addr, coord, title, inloData } = props;
  const [mapSource, setMapSource] = useState("base");
  const [map, setMap] = useState(null);
  const [selectedData, setSelectedData] = useState(
    addr + "," + coord.lat + "," + coord.lng + "," + title
  );
  const [markers, setMarkers] = useState([]);

  useEffect(() => {
    const markers = [];
    const data = {
      facNo: 0,
      key: "1",
      coord: coord,
      title: title ? title : "띵스파이어",
    };
    markers.push(makeMarker(data, container2, null));
    setMarkers(markers);
  }, []);

  const MapClickEvent = () => {
    const map = useMapEvents({
      click: (e) => {
        let coord = e.latlng;
        setSelectedData(coord.lat + "," + coord.lng);
        clickMap(coord);

        const markers = [];
        const data = {
          facNo: 0,
          key: "1",
          coord: coord,
          title: title ? title : "띵스파이어",
        };
        markers.push(makeMarker(data, container2, null));
        setMarkers(markers);
      },
    });
    return null;
  };

  return (
    <>
      <div className="test">{selectedData}</div>
      <MapContainer
        attributionControl={false}
        style={{ height: "720px", width: "100%" }}
        center={coord ? [coord.lat, coord.lng] : THINGSPIRE_LAT_LNG}
        zoom={15}
        scrollWheelZoom={true}
        id={props.id}
        whenReady={setMap}
      >
        <TileLayer
          url={
            mapSource === "base"
              ? "http://api.vworld.kr/req/wmts/1.0.0/2AA43519-BFAB-3324-9DDF-DB6B567A0DDC/Base/{z}/{y}/{x}.png"
              : mapSource === "midnight"
              ? "http://api.vworld.kr/req/wmts/1.0.0/E6E8A8C3-EF10-371F-81EA-97B22903FCE5/midnight/{z}/{y}/{x}.png"
              : mapSource === "gray"
              ? "http://api.vworld.kr/req/wmts/1.0.0/E6E8A8C3-EF10-371F-81EA-97B22903FCE5/gray/{z}/{y}/{x}.png"
              : mapSource === "Hybrid"
              ? "http://api.vworld.kr/req/wmts/1.0.0/E6E8A8C3-EF10-371F-81EA-97B22903FCE5/Hybrid/{z}/{y}/{x}.png"
              : ""
          }
          attribution="VWorldBase"
        />
        {markers}
      </MapContainer>
    </>
  );
};

export const FxMapContainer = (props) => {
  const { id, fxUiGrpItem, editable, inloData } = props;
  const [markerDatas, setMarkerDatas] = useState([]);
  const dispatch = useDispatch();

  async function loadFacility() {

    //console.log("*** FxMapContainer ***", JSON.stringify(inloData));

    const ret = [];
    for (let inlo of inloData) {
      if (inlo.inloNo !== undefined || inlo.inloNo !== 0) {
        //const inlo = FxmsData.getInlo(data.inloNo);
        if (inlo) {
          inlo.ltd = inlo.ltd;
          inlo.lnd = inlo.lnd;
          inlo.inloAddr = inlo.addr;
          inlo.inloName = inlo.inloName;
        }
      }

      ret.push({
        ...inlo,
        key: inlo.inloNo,
        coord: {
          lat: inlo.ltd ? inlo.ltd : THINGSPIRE_LAT_LNG[0],
          lng: inlo.lnd ? inlo.lnd : THINGSPIRE_LAT_LNG[1],
        },
        addr: inlo.inloAddr,
        title: inlo.inloName,
      });
    }

    console.log("*** FxMapContainer ***", ret);

    setMarkerDatas(ret);
  }

  useEffect(() => {
    console.log("*** FxMapContainer ***", props);

    loadFacility();
  }, []);

  return (
    <>
    <FxMap
      id={id}
      fxUiGrpItem={fxUiGrpItem}
      editable={editable}
      markerDatas={markerDatas}
      inloData={inloData}
    />
    </>
  );
};

/**
 * 맵 설정
 * 개발자 : T/F팀
 * 개발년원 : 2022.11
 * @param {*} fxUiGrp
 * @param {*} fxUiGrpItem
 * @returns
 */
export function FxMapContainerConfig(fxUiGrp, fxUiGrpItem) {

  const setList = new AttrListEdit("setting");
  setList.makeAttrSelect(10, "facClCd", "지도에 보일 설비 종류를 선택하세요", 300, "code", { cdClass: "FAC_CL_CD" });
  setList.makeAttrButton(40, "btnSave", "적용", 100, null, function (data) {
    FxmsData.updateUi(fxUiGrp, fxUiGrpItem, data);
  });

  return setList;

}

export { FxMap };
